import module from 'app/module.js'
import { element } from 'angular'

class AppTableColumnComponent {
  constructor ($element, $scope, $transclude) {
    this.$element = $element
    this.$scope = $scope
    this.$transclude = $transclude
    this.appTable = null
    this.appTableColumn = null
    this.width = 'auto'
  }

  $postLink () {
    if (this.$element.attr('width')) {
      this.width = this.$element.attr('width')
    }

    this.appTable.columns.add(this.$element, this)
  }

  $onDestroy () {
    this.appTable.columns.remove(this)
  }

  getCell (locals, cloneAttachFn) {
    if (this.$transclude.isSlotFilled('cell')) {
      let scope = Object.assign(this.$scope.$new(), locals)

      this.$transclude(scope, cloneAttachFn, null, 'cell')
    } else {
      cloneAttachFn(element('<app-table-cell></app-table-cell>'))
    }
  }

  getHeader (locals, cloneAttachFn) {
    if (this.$transclude.isSlotFilled('header')) {
      let scope = Object.assign(this.$scope.$new(), locals)

      this.$transclude(scope, cloneAttachFn, null, 'header')
    } else {
      cloneAttachFn(element('<app-table-header></app-table-header>'))
    }
  }
}

module.directive('appTableColumn', () => {
  return {
    restrict: 'E',
    controller: AppTableColumnComponent,
    require: {
      appTable: '^^appTable',
      appTableColumn: 'appTableColumn',
    },
    terminal: true,
    bindings: {},
    transclude: {
      cell: '?appTableCell',
      header: '?appTableHeader',
    },
    compile () {
      return {
        pre (scope, iElement, iAttrs, ctrl) {
          ctrl.appTableColumn['appTable'] = ctrl.appTable
        },
      }
    },
  }
})



// WEBPACK FOOTER //
// ./src/app/components/table/column/component.js